import React, { useEffect, useState } from 'react';
import Card from '../components/ui/Card';
import Btn from '../components/ui/Btn';
import Badge from '../components/ui/Badge';
import { Input } from '../components/ui/Input';
import CadastroEmpresaForm from './cadastros/CadastroEmpresaForm';
import PagamentoFornecedorTab from './cadastros/tabs/PagamentoFornecedorTab';
import { fornecedoresApi } from '../api/fornecedores';
import { COLORS } from '../theme';

const abaExtra = { titulo: 'Pagamento', Componente: PagamentoFornecedorTab };

export default function Fornecedores() {
  const [fornecedores, setFornecedores] = useState([]);
  const [busca, setBusca] = useState('');
  const [registroAberto, setRegistroAberto] = useState(undefined);

  const carregar = () => fornecedoresApi.listar(busca ? { busca } : {}).then(setFornecedores).catch(() => {});
  useEffect(() => { carregar(); }, [busca]); // eslint-disable-line

  const alternarAtivo = async (fornecedor) => {
    const acao = fornecedor.ativo ? 'desativar' : 'reativar';
    if (!window.confirm(`Tem certeza que quer ${acao} o fornecedor "${fornecedor.nome_fantasia}"?`)) return;
    await fornecedoresApi.atualizar(fornecedor.id, { ativo: fornecedor.ativo ? 0 : 1 });
    carregar();
  };

  if (registroAberto !== undefined) {
    return (
      <CadastroEmpresaForm
        titulo="Fornecedor"
        api={fornecedoresApi}
        registroId={registroAberto}
        onVoltar={() => { setRegistroAberto(undefined); carregar(); }}
        onSalvo={carregar}
        exibirComercial={false}
        exibirEnderecosExtras={false}
        exibirFrete={true}
        exibirPrazoEntrega={true}
        exibirHistoricoCompras={true}
        abaExtra={abaExtra}
      />
    );
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <Input placeholder="Buscar por nome ou CNPJ/CPF..." value={busca} onChange={e => setBusca(e.target.value)} style={{ width: 320 }} />
          <Btn onClick={() => setRegistroAberto(null)}>+ Novo Fornecedor</Btn>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Nome Fantasia</th>
              <th style={{ padding: 10 }}>CNPJ/CPF</th>
              <th style={{ padding: 10 }}>Telefone</th>
              <th style={{ padding: 10 }}>Cidade/UF</th>
              <th style={{ padding: 10 }}>Status</th>
              <th style={{ padding: 10 }}></th>
            </tr>
          </thead>
          <tbody>
            {fornecedores.map(f => (
              <tr key={f.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10, cursor: 'pointer' }} onClick={() => setRegistroAberto(f.id)}>{f.nome_fantasia}</td>
                <td style={{ padding: 10 }}>{f.cnpj_cpf || '-'}</td>
                <td style={{ padding: 10 }}>{f.telefone1 || '-'}</td>
                <td style={{ padding: 10 }}>{f.end_principal_cidade ? `${f.end_principal_cidade}/${f.end_principal_uf || ''}` : '-'}</td>
                <td style={{ padding: 10 }}>{f.ativo ? <Badge tom="sucesso">Ativo</Badge> : <Badge tom="perigo">Inativo</Badge>}</td>
                <td style={{ padding: 10, display: 'flex', gap: 8 }}>
                  <Btn tamanho="sm" variante="ghost" onClick={() => setRegistroAberto(f.id)}>Editar</Btn>
                  <Btn tamanho="sm" variante={f.ativo ? 'danger' : 'secondary'} onClick={() => alternarAtivo(f)}>
                    {f.ativo ? 'Desativar' : 'Reativar'}
                  </Btn>
                </td>
              </tr>
            ))}
            {fornecedores.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum fornecedor cadastrado ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
